import { Component } from '@angular/core';

@Component({
  selector: 'app-project-links',
  standalone: true,
  imports: [],
  templateUrl: './project-links.component.html',
  styleUrl: './project-links.component.scss'
})
export class ProjectLinksComponent {

}
